import sendReportRequest from './sendReportRequest';

const fetchReportRepeatCustomers = async ({ dateRange, from, to, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/repeatCustomers',
    dateRange,
    from,
    to,
    reportingType,
  });

  return reponseData;
};

export default fetchReportRepeatCustomers;
